import styles from './select.module.css'

const Select = ({ children, ...props }) => {
  return <select {...props} className={styles.select}>{children}</select>
}

export default Select
